















/* globals process */
import Vue from 'vue';
import { AuthService } from '@/services';

export default Vue.extend({
  name: 'PageHeader',
  data() {
    return {
      clientName: process.env.CLIENT_NAME,
    };
  },
  computed: {
    isAuthenticated(): boolean {
      return AuthService.isAuthenticated;
    },
  },
  methods: {
    signOut() {
      AuthService.signOutUser(true);
    },
  },
});
